import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { UntypedFormBuilder, Validators, UntypedFormGroup, AbstractControl } from "@angular/forms";
import {UserInfoService, MsalToken} from "../../../user-info.service";
import { UserProvisioningService } from "../../../services/user/user-provisioning.service";

interface ManageUserDialogData {
  id: number;
  email: string;
  lastName: string;
  firstName: string;
}

@Component({
    selector: 'app-manage-user',
    templateUrl: './manage-user.component.html',
    styleUrls: ['./manage-user.component.scss'],
    standalone: false
})
export class ManageUserComponent implements OnInit, OnDestroy {
  user: ManageUserDialogData;

  subscriptions: Subscription[] = [];
  form: UntypedFormGroup;
  isAdd: boolean;

  constructor(private formBuilder: UntypedFormBuilder,
    private userInfo: UserInfoService,
    private userProvisionService: UserProvisioningService,
    private dialogRef: MatDialogRef<ManageUserComponent>,
    @Inject(MAT_DIALOG_DATA) user: ManageUserDialogData
  ) {
    this.user = user;
  }

  get email():AbstractControl {
    return this.form.get('email');
  }

  get firstName():AbstractControl {
    return this.form.get('firstName');
  }

  get lastName():AbstractControl {
    return this.form.get('lastName');
  }

  ngOnInit() {
    this.isAdd = !this.user;
    this.initForm();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((s => s.unsubscribe()));
  }

  save() {
    let currentToken: MsalToken;
    if(localStorage.getItem("adLogin") === "true"){
      try {
        currentToken = JSON.parse(localStorage.getItem("adTokens"));
        if(!currentToken || !currentToken?.accessToken){
          this.userInfo.logout()
        }
      } catch (e) {
        this.userInfo.logout()
      }
    }
    if (this.isAdd) {
      const postData = {
        email: this.email.value,
        firstName: this.firstName.value,
        lastName: this.lastName.value,
        provisioner: {
          adAccessToken: currentToken?.accessToken
        }
      };
      this.userProvisionService.addUser(postData);
      this.dialogRef.close(true);

    } else {
      const postData = {
        email: this.email.value,
        provisioner: {
          adAccessToken: currentToken?.accessToken
        }
      };
      this.userProvisionService.removeUser(this.user.id, postData);
      this.dialogRef.close(true);
    }
  }

  onClose() {
    this.dialogRef.close(false);
  }

  formatter(option) {
    return option.label;
  }

  private initForm() {
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern('(^[a-z0-9]{4,}-[a-z0-9]{4,}-[a-z0-9]{4,}-.*[a-z0-9]{4,}|^.*@.*\..*$)')]],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required]
    });
    this.email.setValue("");
    this.firstName.setValue("");
    this.lastName.setValue("");

    if (!this.isAdd) {
      this.email.disable();
      this.firstName.disable();
      this.lastName.disable();
      this.email.setValue(this.user.email);
      this.firstName.setValue(this.user.firstName);
      this.lastName.setValue(this.user.lastName);
    }
  }
}

